/**
 * Detail's code chunk, loaded once and then rendered directly.
 *
 * React.lazy suspends on its first render even when the chunk is already in
 * hand, and a suspended boundary waits React's ~300 ms fallback throttle
 * before showing the page — measured 2026-10-14 as a 325 ms dead first tap on
 * the People → Detail opening (DETAIL §9a; every later open: ~15 ms). So
 * People fetches the chunk while it's up, and App renders the loaded module
 * straight away; lazy() only covers a cold start (a deep link to Detail).
 */
let loaded = null;

export const loadDetailScreen = () =>
  import('./DetailScreen').then((m) => {
    loaded = m.default;
    return m;
  });

/** The Detail screen component once its chunk has arrived, else null. */
export const loadedDetailScreen = () => loaded;
